import React from 'react';
import { ChevronDown } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: SelectOption[];
  error?: string;
  placeholder?: string;
}
export function Select({
  label,
  options,
  error,
  placeholder = 'Select an option',
  className = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || props.name;
  return <div className="w-full" data-id="element-533">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-534">
          {label}
        </label>}
      <div className="relative" data-id="element-535">
        <select id={selectId} className={`
            block w-full rounded-lg border-gray-300 shadow-sm appearance-none
            focus:border-[#FFD700] focus:ring-[#FFD700] sm:text-sm py-3 pl-3 pr-10
            bg-white
            ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300'}
            ${className}
          `} {...props} data-id="element-536">
          <option value="" disabled data-id="element-537">
            {placeholder}
          </option>
          {options.map(option => <option key={option.value} value={option.value} data-id="element-538">
              {option.label}
            </option>)}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-500" data-id="element-539">
          <ChevronDown className="h-4 w-4" data-id="element-540" />
        </div>
      </div>
      {error && <p className="mt-1 text-sm text-red-600" role="alert" data-id="element-541">
          {error}
        </p>}
    </div>;
}